module.exports = __webpack_public_path__ + "img/Skype.55e471df.svg";